<div class="detail-container">
  <nb-card [nbSpinner]="loader()">
    <nb-card-header>
      <div class="header-content">
        <button nbButton ghost status="primary" (click)="navigateBack()">
          <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
        </button>

        <h5 class="title">
          @if (buildingApplication()?.baseData?.sectionText) {
            {{buildingApplication()?.baseData?.sectionText}}
          } @else {
            Neuer Gebäudeantrag
          }
        </h5>

        @if (buildingApplication()?.status === applicationStatus.Rejected) {
          <wr-banner class="reject-comment"
                     [icon]="{icon: 'alert-triangle-outline', pack: 'eva'}"
                     status="danger"
                     [message]="buildingApplication()?.rejectComment ?? 'Keine Angaben'">
          </wr-banner>
        }

        @if (editable() && !isEditing()) {
          <button nbButton ghost status="primary" (click)="toggleEdit()" class="edit-button">
            <nb-icon pack="eva" icon="edit-outline"></nb-icon>
          </button>
        }
      </div>
    </nb-card-header>

    <nb-card-body>
      <hau-form *ngIf="form()" [formGroup]="form()">
        <nb-tabset>
          <nb-tab [tabTitle]="baseDateTab">
            <wr-building-base-data-form formControlName="baseData"></wr-building-base-data-form>
            <wr-building-allocation-form formControlName="allocationData" [showTeamRegion]="false"></wr-building-allocation-form>
            <wr-building-access-form formControlName="accessData"></wr-building-access-form>
            <wr-building-amenity-form formControlName="amenityData"></wr-building-amenity-form>
          </nb-tab>

          <nb-tab [tabTitle]="buildingSectionTab">
            <wr-building-section-editor formControlName="buildingSections"></wr-building-section-editor>
          </nb-tab>
        </nb-tabset>
      </hau-form>
    </nb-card-body>

    @if (!buildingApplication()?.status) {
    <nb-card-footer>
      <button nbButton status="primary" (click)="submitBuildingData()" [disabled]="form().invalid || loader()">
        Antrag erstellen
      </button>
    </nb-card-footer>
    }

    @if (isEditing() && buildingApplicationId() !== 'new') {
      <nb-card-footer>
        <button nbButton status="primary"
                (click)="reSubmitAfterRejection()"
                [disabled]="form().invalid || loader()">
          Antrag erneut abgeben
        </button>
      </nb-card-footer>
    }
  </nb-card>
</div>
